'use strict';

var _ = require('lodash');
var angular = require('angular');
var FaresOptimizerAuditLogModalController = function FaresOptimizerAuditLogModalController($scope) {
  $scope.handleModalHideAndResetItsState = function () {
    angular.element('body').removeClass('modal-open');
    angular.element('.modal-backdrop').remove();
  };
};
FaresOptimizerAuditLogModalController.$inject = ['$scope'];
module.exports = FaresOptimizerAuditLogModalController;